// Reports tab — PDF / XLSX / CSV exports.
import { useState } from "react";
import { Card } from "./OverviewTab";
import { Button } from "@/components/ui/button";
import { Download, FileText, FileSpreadsheet, FileType, BarChart3, Truck, Receipt, Megaphone, Boxes } from "lucide-react";
import { downloadReport } from "@/lib/analytics";
import { toast } from "sonner";

const REPORTS = [
  { id: "profit", name: "Raport profit & contabilitate", desc: "Venit, COGS, ads, livrare, TVA, profit net, breakdown pe județ + furnizor.", icon: Receipt },
  { id: "sales", name: "Raport vânzări", desc: "Trenduri zilnice, AOV, comenzi, vânzări pe județ.", icon: BarChart3 },
  { id: "products", name: "Raport produse", desc: "Top vândute, profitabile, retururi, marjă, COGS, retururi per produs.", icon: Boxes },
  { id: "stock", name: "Raport stoc & previziuni", desc: "Necesar aprovizionare, velocity, zile rămase, cantitate sugerată.", icon: Truck },
  { id: "marketing", name: "Raport marketing", desc: "Spend zilnic, ROAS, CPA, performanță per canal.", icon: Megaphone },
];

const FORMATS = [
  { id: "xlsx", label: "Excel", icon: FileSpreadsheet, color: "text-emerald-500" },
  { id: "pdf", label: "PDF", icon: FileType, color: "text-rose-500" },
  { id: "csv", label: "CSV", icon: FileText, color: "text-cyan-500" },
];

export default function ReportsTab({ range }) {
  const [busy, setBusy] = useState(null);
  const download = async (report, format) => {
    const key = `${report}-${format}`;
    setBusy(key);
    try {
      await downloadReport(report, format, range);
      toast.success(`Raport descărcat (${format.toUpperCase()})`);
    } catch (e) { toast.error("Eroare la descărcare"); }
    finally { setBusy(null); }
  };
  return (
    <div className="space-y-6" data-testid="analytics-reports">
      <Card title="Rapoarte de export">
        <div className="text-sm text-muted-foreground mb-4">
          Rapoartele se generează pe intervalul selectat din header. Folosite frecvent pentru contabilitate, audit financiar și share cu echipa.
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {REPORTS.map((r) => {
            const Icon = r.icon;
            return (
              <div key={r.id} className="rounded-xl border border-border bg-card/50 p-4 flex flex-col gap-3 hover:border-primary/40 transition-colors" data-testid={`report-${r.id}`}>
                <div className="flex items-start gap-3">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold">{r.name}</div>
                    <div className="text-xs text-muted-foreground mt-0.5">{r.desc}</div>
                  </div>
                </div>
                <div className="flex gap-1.5 mt-1">
                  {FORMATS.map((f) => {
                    const Fi = f.icon;
                    const key = `${r.id}-${f.id}`;
                    return (
                      <Button
                        key={f.id}
                        variant="outline"
                        size="sm"
                        className="flex-1"
                        disabled={busy === key}
                        onClick={() => download(r.id, f.id)}
                        data-testid={`report-${r.id}-${f.id}`}
                      >
                        <Fi className={`h-3.5 w-3.5 mr-1.5 ${f.color}`} />
                        {busy === key ? "..." : f.label}
                      </Button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
